import React from "react";
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import Icon from "../Utils/Icon";
import Amount from "../Utils/Amount";
import classes from "./styles.module.css";

function formatKopecks(value) {
    if (value === null || value === undefined) {
        return '0.00';
    }
    var floatVal = Number(value) / 100;
    return floatVal.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export default function TableRow({data, hasExtendedBalances}) {
    return (
        <tr className={classes.Row}>
            <td>{(data && data.displayName) || ""}</td>
            {hasExtendedBalances ? (
                <React.Fragment>
                    <td className={classes.AmountCell}>
                        {data && data.balance && data.balance.length > 0 ? (
                            data.balance.map(function (el, index) {
                                var currency = Object.keys(el)[0];
                                var amount = el[currency];
                                return (
                                    <span key={index}>
                                        <Amount amount={amount} currency={currency}/>
                                    </span>
                                );
                            })
                        ) : (
                            <span>—</span>
                        )}
                    </td>
                    <td className={classes.AmountCell}>
                        {data && data.settlementBalance !== undefined ? (
                            <span>{formatKopecks(data.settlementBalance)} &#8381;</span>
                        ) : (
                            <span>—</span>
                        )}
                    </td>
                    <td className={classes.AmountCell}>
                        {data && data.actualBalance !== undefined ? (
                            <span>{formatKopecks(data.actualBalance)} &#8381;</span>
                        ) : (
                            <span>—</span>
                        )}
                    </td>
                </React.Fragment>
            ) : (
                <td className={classes.AmountCell}>
                    {data && data.balance && data.balance.length > 0 ? (
                        data.balance.map(function (el, index) {
                            var currency = Object.keys(el)[0];
                            var amount = el[currency];
                            return (
                                <span key={index}>
                                    <Amount amount={amount} currency={currency}/>
                                </span>
                            );
                        })
                    ) : (
                        <span>—</span>
                    )}
                </td>
            )}
            <td>
                {data && data.status === 1 ? (
                    <div className={classes.Enables}>
                        <FormattedMessage id="ProjectsTable.status.active" defaultMessage="Активен"/>
                    </div>
                ) : (
                    <div className={classes.Disabled}>
                        <FormattedMessage id="ProjectsTable.status.blocked" defaultMessage="Заблокирован"/>
                    </div>
                )}
            </td>
            <td>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.Link}
                    href={data && data.url}
                >
                    {(data && data.url && data.url.replace(/^([a-zA-Z]+):\/\//, "")) || ""}
                </a>
            </td>
            <td className={classes.CellLeft}>
                <Link className={classes.Settings} to={'/projects/settings/' + ((data && data.uuid) || "")}>
                    <Icon className={classes.Icon} icon="settings" size="14px"/>
                    <FormattedMessage id="ProjectsTable.link.settings" defaultMessage="Настройки"/>
                </Link>
            </td>
        </tr>
    );
}



// WEBPACK FOOTER //
// ./src/Components/ProjectsTable/TableRow.js